namespace GeniuzPOS.InitialData {
    export interface PsCustomerSurveyPosRow {
        Id?: number;
        SurveyCode?: string;
        PosId?: string;
    }

    export namespace PsCustomerSurveyPosRow {
        export const idProperty = 'SurveyCode';
        export const nameProperty = 'SurveyCode';
        export const localTextPrefix = 'InitialData.PsCustomerSurveyPos';
        export const deletePermission = '1POSBASE:ข้อมูลอ้างอิง:การจัดการจุดขาย:CustomerSurvey:Modify';
        export const insertPermission = '1POSBASE:ข้อมูลอ้างอิง:การจัดการจุดขาย:CustomerSurvey:Modify';
        export const readPermission = '1POSBASE:ข้อมูลอ้างอิง:การจัดการจุดขาย:CustomerSurvey:View';
        export const updatePermission = '1POSBASE:ข้อมูลอ้างอิง:การจัดการจุดขาย:CustomerSurvey:Modify';

        export declare const enum Fields {
            Id = "Id",
            SurveyCode = "SurveyCode",
            PosId = "PosId"
        }
    }
}
